











































import { defineComponent } from "@vue/composition-api";
import { getPostAllowedFileTypes, isMediaFile } from "@/lib/fileHelpers";
import { PostFileData } from "@/types";
import BaseIcon from "@/components/BaseIcon";
import BaseInputFile from "@/components/BaseInputFile";
import MediaFileAddButton from "@/components/MediaFileAddButton";
import PostFileList from "@/components/PostFileList";
import EditPostDropZone from "../EditPostDropZone";
import PostFileThumbnail from "../PostFileThumbnail";
import PreviewSetButton from "../PreviewSetButton";

interface Lists {
  thumbnails: PostFileData[];
  rows: PostFileData[];
}

export default defineComponent({
  name: "AddFiles",
  components: {
    BaseIcon,
    BaseInputFile,
    PostFileThumbnail,
    EditPostDropZone,
    PostFileList,
    PreviewSetButton,
    MediaFileAddButton,
  },
  props: {
    fileList: { type: Array as () => PostFileData[], required: true },
    showPublicButton: { type: Boolean, default: false },
  },
  computed: {
    lists(): Lists {
      const initialLists: Lists = { thumbnails: [], rows: [] };
      return this.fileList.reduce((out, postFile) => {
        if (isMediaFile(postFile)) out.thumbnails.push(postFile);
        else out.rows.push(postFile);
        return out;
      }, initialLists);
    },
    allowedFileTypes(): string[] {
      return getPostAllowedFileTypes();
    },
  },
});
